<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('S430', 'en-US')"
        class="card-panel"
        :header="uniTranslation('S430')"
        style="height:100%; margin-bottom: 0px !important"
        :style="{ backgroundColor: coloreSfondo }"
      >
        <FluidPicker :path="path"></FluidPicker>

        <UnidataEditor :parent-path="path" :name="'.inletTemperature'"></UnidataEditor>

        <UnidataEditorCorrelatorOptionList
          :parent-path="path"
          :selected-option-index.sync="flowRadioIndex"
          group="FluidFlowTemp"
        ></UnidataEditorCorrelatorOptionList>

        <div>
          <UnidataEditor :parent-path="path" :name="'.fluidVelocity'"></UnidataEditor>
        </div>

        <UnidataEditor :parent-path="path" :name="'.pressureDrop'"></UnidataEditor>

        <div>
          <UnidataEditor :parent-path="path" :name="'.foulingFactor'"></UnidataEditor>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FluidPicker from "../shared/FluidPicker";
import UnidataEditor from "../unidata/UnidataEditor";
// import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
// import { Radio, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    FluidPicker,
    UnidataEditor,
    // UnidataEditorCorrelator,
    UnidataEditorCorrelatorOptionList /*,
    "el-radio": Radio,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      flowRadioIndex: 0,
      coloreSfondo: ""
    };
  },
  computed: {
    ...mapGetters(["_prjModule"]),
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    flowRadioIndex: function(newval /*, oldval*/) {
      //alert(this.path + " " + newval);
      //this.$store.dispatch('changeFluidCalculationModeProperty',newval);

      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".flowRadioIndex",
        value: newval
      });
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    var that = this;
    that.coloreSfondo = that.cardColors[0] + " !important";
  },
  methods: {
    /*...mapActions([
        'increment'
      ])*/
  }
};
</script>

<style lang="scss"></style>

<!--
<style lang="scss">

div{
  hr{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata{
    display:flex;
    flex-direction: row;
    .radio-container{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width:160px;
      label{
        margin-bottom: 0px;
      }
      .el-radio + .el-radio{
        margin-left: 0px
      }
    }
  }
}


</style>
-->
